import { Navigate, NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Truck, Inbox, Settings, UserCog, LogOut, ExternalLink, PhoneCall, MessagesSquare, Star } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { LogoMark } from "../../context/BrandContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
  { to: "/admin/shipments", label: "Shipments", icon: Truck, id: "shipments" },
  { to: "/admin/messages", label: "Messages", icon: Inbox, id: "messages" },
  { to: "/admin/leads", label: "Chat Leads", icon: PhoneCall, id: "leads" },
  { to: "/admin/chats", label: "Chats", icon: MessagesSquare, id: "chats" },
  { to: "/admin/reviews", label: "Reviews", icon: Star, id: "reviews" },
  { to: "/admin/settings", label: "Settings", icon: Settings, id: "settings" },
  { to: "/admin/account", label: "Account", icon: UserCog, id: "account" },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500" data-testid="admin-loading">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return (
    <div className="min-h-screen bg-[#F7F8FA] lg:flex" data-testid="admin-layout">
      <aside className="lg:w-60 lg:min-h-screen bg-white border-b lg:border-b-0 lg:border-r border-slate-200 lg:sticky lg:top-0 lg:h-screen flex lg:flex-col">
        <Link to="/admin" className="hidden lg:flex items-center gap-3 px-5 h-16 border-b border-slate-200" data-testid="admin-logo">
          <LogoMark size="w-9 h-9" testid="admin-logo-mark" />
          <span className="font-display font-extrabold uppercase text-brand-600 leading-none">Echevarria<br /><span className="text-[11px] tracking-[0.2em] text-slate-500">Admin</span></span>
        </Link>
        <nav className="flex lg:flex-col overflow-x-auto lg:overflow-visible flex-1 lg:p-3 gap-1">
          {NAV.map(({ to, label, icon: I, end, id }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${id}`}
              className={({ isActive }) => `flex items-center gap-2.5 px-4 lg:px-3 h-12 lg:h-10 text-sm font-medium whitespace-nowrap transition-colors ${isActive ? "bg-brand-50 text-brand-700 lg:border-l-2 border-b-2 lg:border-b-0 border-brand-600" : "text-slate-700 hover:bg-slate-100"}`}>
              <I className="w-4 h-4" />{label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:block p-3 border-t border-slate-200 text-xs text-slate-500">
          <div className="px-3 pb-2 truncate" data-testid="admin-user-email">{user.email}</div>
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-3 h-9 hover:bg-slate-100 text-slate-700" data-testid="admin-view-site"><ExternalLink className="w-4 h-4" />View site</a>
          <button onClick={logout} className="w-full flex items-center gap-2 px-3 h-9 hover:bg-slate-100 text-slate-700" data-testid="admin-logout-button"><LogOut className="w-4 h-4" />Log out</button>
        </div>
        <button onClick={logout} className="lg:hidden px-4 text-slate-700" data-testid="admin-logout-button-mobile" aria-label="Log out"><LogOut className="w-4 h-4" /></button>
      </aside>
      <main className="flex-1 min-w-0 p-5 sm:p-8 lg:p-10">
        <Outlet />
      </main>
    </div>
  );
};
